module.exports = __webpack_public_path__ + "img/kanako yasaka_sc2.c27005ff.png";